import type { StepProps } from '../types';
import { CurrencyField, ToggleField } from '../fields';

export default function BusinessStep({ input, onChange, filingStatus }: StepProps) {
  // Spouse boxes only on a joint return, as on the Income step; the engine
  // ignores spouse income on every other status.
  const isMFJ = (filingStatus ?? input.filingStatus) === 'MFJ';
  return (
    <div className="space-y-8" data-tour="business-step">
      <div data-tour="business-taxpayer">
        <h3 className="text-sm font-semibold mb-1">Taxpayer — Schedule C</h3>
        <p className="text-xs text-muted-foreground mb-4">Self-employment income and expenses for the primary taxpayer.</p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          <CurrencyField label="Gross Receipts" value={input.schedCGrossReceipts} onChange={v => onChange('schedCGrossReceipts', v)} hint="Schedule C line 1" />
          <CurrencyField label="Total Expenses" value={input.schedCTotalExpenses} onChange={v => onChange('schedCTotalExpenses', v)} hint="Schedule C line 28" />
          <CurrencyField label="Taxpayer W-2 SS Wages" value={input.w2SocialSecurityWages} onChange={v => onChange('w2SocialSecurityWages', v)} hint="W-2 box 3 · blank uses Wages" />
        </div>
      </div>

      {isMFJ && (
        <div data-tour="business-spouse">
          <h3 className="text-sm font-semibold mb-1">Spouse — Schedule C</h3>
          <p className="text-xs text-muted-foreground mb-4">Spouse's separate self-employment income.</p>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            <CurrencyField label="Spouse Gross Receipts" value={input.spouseSchedCGrossReceipts} onChange={v => onChange('spouseSchedCGrossReceipts', v)} hint="Schedule C line 1 (spouse's)" />
            <CurrencyField label="Spouse Total Expenses" value={input.spouseSchedCTotalExpenses} onChange={v => onChange('spouseSchedCTotalExpenses', v)} hint="Schedule C line 28 (spouse's)" />
            <CurrencyField label="Spouse W-2 SS Wages" value={input.spouseW2SocialSecurityWages} onChange={v => onChange('spouseW2SocialSecurityWages', v)} hint="W-2 box 3 · blank uses Spouse Wages" />
          </div>
        </div>
      )}

      <div data-tour="business-qbi">
        <h3 className="text-sm font-semibold mb-1">QBI — Qualified Business Income</h3>
        <p className="text-xs text-muted-foreground mb-4">Used for the §199A deduction phase-in calculation.</p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          <CurrencyField label="QBI W-2 Wages Paid" value={input.qbiW2Wages} onChange={v => onChange('qbiW2Wages', v)} hint="Form 8995-A line 4 — W-2 wages paid by the qualified business" />
          <CurrencyField label="QBI UBIA" value={input.qbiUBIA} onChange={v => onChange('qbiUBIA', v)} hint="Form 8995-A line 7 — unadjusted basis of qualified property" />
          <ToggleField label="Specified Service (SSTB)" value={input.qbiSSTB} onChange={v => onChange('qbiSSTB', v)} hint="Form 8995-A — specified service trade or business" />
        </div>
      </div>
    </div>
  );
}
